/** Typical horizontal padding on filter popovers (e.g. 12px + 12px). */
export const FILTER_PANEL_PADDING_X = 24;

/** minWidth 180 + typical padding (10px + 12px). */
export const FILTER_PANEL_WIDTH_STANDARD = 204;
/** minWidth 190 + typical padding. */
export const FILTER_PANEL_WIDTH_COMPACT = 214;
/** minWidth 200 + typical padding. */
export const FILTER_PANEL_WIDTH_MEDIUM = 224;
/** minWidth 220 + 12px padding each side. */
export const FILTER_PANEL_WIDTH_WIDE = 244;
/** 240px inner content + padding (numeric filters with operator row). */
export const FILTER_PANEL_WIDTH_NUMERIC = 264;

/** Default for column filter popovers using NumericFilterContent. */
export const FILTER_PANEL_WIDTH = FILTER_PANEL_WIDTH_NUMERIC;

export const OP_DROPDOWN_WIDTH = 190;
/** Six operator rows at ~36px each */
export const OP_DROPDOWN_EST_HEIGHT = 216;

export function filterPanelOuterWidth(minWidth, paddingX = FILTER_PANEL_PADDING_X) {
  return minWidth + paddingX;
}

export function calcPanelLeft(rect, panelWidth) {
  const viewportRight = document.documentElement.clientWidth - 4;
  let left = Math.max(4, rect.left);
  if (left + panelWidth > viewportRight) {
    left = Math.max(4, rect.right - panelWidth);
  }
  if (left + panelWidth > viewportRight) {
    left = Math.max(4, viewportRight - panelWidth);
  }
  return left;
}

export function calcFilterPos(btn, panelWidth = FILTER_PANEL_WIDTH) {
  const r = btn.getBoundingClientRect();
  return { top: r.bottom + 6, left: calcPanelLeft(r, panelWidth) };
}

/** Fixed operator dropdown — opens above the trigger when clipped below the viewport */
export function calcOpDropdownPos(btn, dropdownHeight = OP_DROPDOWN_EST_HEIGHT) {
  const r = btn.getBoundingClientRect();
  const left = calcPanelLeft(r, OP_DROPDOWN_WIDTH);
  const gap = 4;
  const belowTop = r.bottom + gap;
  const aboveTop = r.top - gap - dropdownHeight;
  const spaceBelow = window.innerHeight - belowTop;
  const spaceAbove = r.top - gap;
  const openBelow = spaceBelow >= dropdownHeight || spaceBelow >= spaceAbove;
  let top = openBelow ? belowTop : Math.max(4, aboveTop);
  if (top + dropdownHeight > window.innerHeight - 4) {
    top = Math.max(4, window.innerHeight - 4 - dropdownHeight);
  }
  return { top, left };
}

/** Default compare/timeline version: budget when available, else first non–Live EAC option. */
export function isBudgetVersion(v) {
  if (!v) return false;
  if (v.key === "budget") return true;
  return /^budget\b/i.test(String(v.name || "").trim());
}

export function resolveDefaultBudgetVersion(versions) {
  const opts = (versions || []).filter((v) => v.key !== "liveEac");
  if (!opts.length) return "";
  const byKey = opts.find((v) => v.key === "budget");
  if (byKey) return byKey.key;
  const byName = opts.find((v) => isBudgetVersion(v));
  if (byName) return byName.key;
  return opts[0].key;
}

/** Prefer Q1 for Compare Forecast Versions; else first option. */
export function resolveDefaultCompareVersion(versions) {
  const opts = versions || [];
  if (!opts.length) return "";
  const q1 = opts.find(
    (v) =>
      /^q1\b/i.test(String(v.key || "").trim()) ||
      /^q1\b/i.test(String(v.name || "").trim()),
  );
  return q1?.key ?? opts[0].key;
}
